// Text & Imageslider
$(".imageSlider-js").each(function (index, element) {
  var $this = $(this);
  var swiper = new Swiper(".slider-simple", {
    slidesPerView: 'auto',
    spaceBetween: 0,
    loop: false,
    freeMode: true, // FreeMode aktiviert
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });
});



// FORM


// Form check if all required fields have a value
$(document).ready(function() {
  $(".form-error-message").removeClass('show-me');
  $('.form-submit .button').click(function(event) {
    var invalid = 0;
    $('.form-required').each(function () {
        if ($(this).val() == '') {
            invalid++;
            if($(".form-checkbox__input.form-required").is(':checked')) {
              $(".form-error-message").removeClass('show-me');
            } else {
              $(".form-error-message").addClass('show-me');
            }
        } else {
          // $('.form-error-message').show();
          if($(".form-checkbox__input.form-required").is(':checked')) {
            if(invalid>0) {
              $(".form-error-message").addClass('show-me');
            } else {
              $(".form-error-message").removeClass('show-me');
            }
          } else {
            $(".form-error-message").addClass('show-me');
          }
        }
    });
    if(invalid>0)
     return false;
    else
     return true;
    });

});


// Form Function Input / Label Focusing
$('.form-input').focus(function(){
  $(this).parents('.form-group').addClass('focused');
});

$('.form-input').blur(function(){
  var inputValue = $(this).val();
  if ( inputValue == "" ) {
    $(this).removeClass('filled');
    $(this).parents('.form-group').removeClass('focused');
  } else {
    $(this).addClass('filled');
  }
});

